import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { spinnerDriverFactory } from './Spinner.driver';
import { Spinner } from '.';

describe('Spinner', () => {
  const createDriver = createRendererWithUniDriver(spinnerDriverFactory);

  it('should render', async () => {
    const { driver } = createDriver(<Spinner />);
    expect(await driver.exists()).toBe(true);
  });
});
